import {Injectable} from '@angular/core';
import {ApiUrlConstants} from '@coreconstant';
import {HttpService, httpConfig} from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class BusinessGoalService {

    baseUrlApi = ApiUrlConstants.BUSINESS_GOAL_BASE_URL;
    httpConfig: httpConfig;

    constructor(
        private _httpService: HttpService
    ) {
    }

    /**
     * Fetches business goals from the API.
     */
    getBusinessGoals() {
        this.httpConfig = {
            url: this.baseUrlApi,
            method: 'get'
        }
        return this._httpService.init(this.httpConfig);
    }
}
